namespace TabAurous.Administration {
    export interface SendCampaignRow {
        ScheduleId?: number;
        Code?: string;
        ScheduleTypeId?: number;
        FixedCode?: string;
        ProviderId?: number;
        CampaignCode?: string;
        Title?: string;
        Message?: string;
        Image?: string;
        Html?: string;
        UseTemplate?: boolean;
        TemplateId?: number;
        Schedule?: string;
        DateTime?: string;
        Recurring?: string;
        Party?: number[];
        ProviderType?: string;
    }

    export namespace SendCampaignRow {
        export const idProperty = 'ScheduleId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.SendCampaign';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ScheduleId = "ScheduleId",
            Code = "Code",
            ScheduleTypeId = "ScheduleTypeId",
            FixedCode = "FixedCode",
            ProviderId = "ProviderId",
            CampaignCode = "CampaignCode",
            Title = "Title",
            Message = "Message",
            Image = "Image",
            Html = "Html",
            UseTemplate = "UseTemplate",
            TemplateId = "TemplateId",
            Schedule = "Schedule",
            DateTime = "DateTime",
            Recurring = "Recurring",
            Party = "Party",
            ProviderType = "ProviderType"
        }
    }
}
